import { message } from "@pankod/refine-antd";
import { useTranslate } from "@pankod/refine-core";
import api from "api/api";
import { useMemo, useRef } from "react";
import ReactQuill, {Quill} from "react-quill";
import "react-quill/dist/quill.snow.css";
import QuillBetterTable from 'quill-better-table'
import htmlEditButton from "quill-html-edit-button";

type Type = {
  value?: string;
  setValue?: (e: any) => void;
  defaultValue?: string;
};
export function CustomQuill({
  value = "",
  setValue = (e: string) => {},
  defaultValue = "",
}: Type) {
  const t = useTranslate();
  const quillRef = useRef<any>();

  const imageHandler = (e: any) => {
    const editor = quillRef.current.getEditor();
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
    input.onchange = async () => {
      const file = input.files![0];
      if (!file) return;
      if (/^image\//.test(file.type)) {
        console.log(file);
        const formData = new FormData();
        formData.append("file", file);
        const res = await api.file.uploadFile(formData); // upload data into server or aws or cloudinary
        if (res.kind === "ok") {
          const url = res?.data?.url;
          editor.insertEmbed(editor.getSelection(), "image", url);
        } else {
          message.error(res.kind);
        }
      } else {
        message.error(t("error.onlyImage"));
      }
    };
  };
  Quill.register({
    'modules/better-table': QuillBetterTable,
    "modules/htmlEditButton": htmlEditButton
  }, true)

  const modules = useMemo(
    () => ({
      // table: false,  // disable table module
      // 'better-table': {
      //   operationMenu: {
      //     items: {
      //       unmergeCells: {
      //         text: 'Another unmerge cells name'
      //       }
      //     }
      //   }
      // },
      // keyboard: {
      //   bindings: QuillBetterTable.keyboardBindings
      // },
      htmlEditButton: {},
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],
          [{ 'align': [] }],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          [{ 'script': 'sub'}, { 'script': 'super' }],   
          ["image", "link", ],
          [{ 'direction': 'rtl' }],  
          ["clean"]
        ],
        handlers: {
          image: imageHandler,
        },
      },
      clipboard: {
        matchVisual: true,
      }
    }),
    []
  );
  const formats = useMemo(
    () => [
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "color",
      "list",
      "bullet",
      "indent",
      "image",
      "link",
      "clean"
    ],
    []
  );


  return (
    <ReactQuill
      value={value}
      onChange={setValue}
      theme="snow"
      formats={formats}
      ref={quillRef}
      defaultValue={defaultValue}
      modules={modules}
    />
  );
}
